module.exports = __webpack_public_path__ + "static/media/menora-logo.26f47224.png";